import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const caseRestClient = new RestClient(atmoClient, "cases");
